import { states } from '@/constants/lifecycle';
import { responseError } from '@/utils/errors';
import withDraft from '@/utils/draftHelper';
import actions from '../constants';
import { findWorkspaceLocations } from './state';

const showWorkspaceLocations = withDraft((draft, { category, code, results }) => {
  const item = findWorkspaceLocations(draft, { category, code });
  item.readStatus = states.SUCCESS;
  item.readErrors = [];
  item.results = results;
});

const showWorkspaceLocationsError = withDraft((draft, action) => {
  const item = findWorkspaceLocations(draft, action);
  item.readStatus = states.ERROR;
  item.readErrors = [responseError(action)];
});

const fetchWorkspaceLocations = withDraft((draft, action) => {
  const item = findWorkspaceLocations(draft, action);
  item.readStatus = states.PENDING;
  item.readErrors = [];
});

export default {
  [actions.FETCH_WORKSPACE_LOCATIONS]: fetchWorkspaceLocations,
  [actions.SHOW_WORKSPACE_LOCATIONS]: showWorkspaceLocations,
  [actions.SHOW_WORKSPACE_LOCATIONS_ERROR]: showWorkspaceLocationsError,
};
